/**
 * Component: PoolExtracciones
 * Package: PoolExtracciones
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\poolExtracciones\PoolExtracciones.js
 *
 * Requisito funcional: RQ08-013
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera una tabla que permite listar los pool almacenados.
 */

import React, { Component } from 'react'
// import { Link } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import ListadoPage from '../../containers/page/ListadoPage'
import FiltrosPoolExtraccionesPage from '../../containers/poolExtracciones/FiltrosPoolExtraccionesPage'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import { date_parser, number_formatter, dateTimeZones } from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'
import {cantidadCeroVacio} from '../comun/table/Stilyzers'

class PoolExtracciones extends Component {
  componentDidMount () {
    document.title = this.props.t('MENU.EXTRACCIONES.POOL') + ' - ' + this.props.t('HEADER.TITLE_GESIPOR')
  }

  onEdit(row) {
    this.props.actions.fromAsignacionView(false)
    this.props.history.push('EditarPoolExtraccion/' + row.idPool)
  }

  render () {    
    const {
      list = [], totales, checkedFiltrosPoolExtracciones, t, numeroRegistrosPorPagina, paginaActual,
      actions: {onDeletePoolExtraccion},
      auth: {separadorDec, separadorMil}
    } = this.props

    const tKey = 'POOL_EXTRACCIONES.'
    const idElemento = 'idPool'
    const table = {
      id: 'poolExtraccionesTable',
      multiHeader: false,
      hasCheckbox: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1),
      idElemento,
      hasOptions: true,
      mostrarModificar: true,
      onEdit: (row) => this.onEdit(row),
      mostrarDuplicar: false,
      mostrarEliminar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1),
      onDelete: (row) => onDeletePoolExtraccion(row.idPool),
      mostrarCambioEstado: false,
      columns: [
        {id: 'nombrePool', name: t(tKey + 'COLUMNS.NOMBRE'), mostrarPoolsPopover: true},
        {id: 'codigo', name: t(tKey + 'COLUMNS.CODIGO'), type: 'numero', numDecimales: 0},
        {id: 'numseguimientos', name: t(tKey + 'COLUMNS.SEGUIMIENTO'), type: 'numero', numDecimales: 0},
        {id: 'fechaExtraccion', name: t(tKey + 'COLUMNS.FECHA'), type: 'fecha'},
        {id: 'nombreRaza', name: t(tKey + 'COLUMNS.RAZA')},
        {id: 'nombreLinea', name: t(tKey + 'COLUMNS.LIN_GENETICA')},
        {id: 'nombreTipoDosis', name: t(tKey + 'COLUMNS.TIPO_DOSIS')},
        {id: 'nombreDiluyente', name: t(tKey + 'COLUMNS.TIPO_DILUYENTE')},
        {id: 'dosisReales', name: t(tKey + 'COLUMNS.N_DOSIS_REALES'), type: 'numero', numDecimales: 0},
        {id: 'volumen', name: t(tKey + 'COLUMNS.VOL'), type: 'numero', numDecimales: 0},
        {id: 'volumenDiluyente', name: t(tKey + 'FORM.FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VOLUMEN_DILUYENTE'), type: 'numero', numDecimales: 0},
        {id: 'porFaTotal', name: t(tKey + 'COLUMNS.FORMAS_ANORMALES'), type: 'numero'},
        //{id: 'indexAvgPool', name: t(tKey + 'COLUMNS.INDEX_MEDIO'), type: 'numero', numDecimales: 2},
        {id: 'nivelGenetico', name: t('FICHA_VERRACO.NUEVO_VERRACO.PARAMETROS.INDEX.MODAL.NIVEL_GENETICO')},
      ],
      rows: list,
      filtros: <FiltrosPoolExtraccionesPage from={'PoolExtracciones'} idElemento={idElemento} />,
      leyenda: [
        {name: t(tKey + 'LEYENDA.POOL_ELIMINADO'), color: '#c4415d'}
      ],
      initialValues: {},
      colorearRow: (row) => {
        let classRow = ''
        if (row.poolEliminado){
          classRow = 'pool-eliminado'
        }
        return classRow
      }
    }
    table.rows.forEach(
      (row, idRow) => {
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          table.initialValues['check' + row[idElemento]] = checkedFiltrosPoolExtracciones
        }
      }
    )

    return (
      
      <div>
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <ListadoPage t_key={tKey} table={table}>
        </ListadoPage>
        <Row className="tablaTotales" style={{ margin: '20px 0px 0px 0px'}}>
          <Col sm={12} className="total-verracos">
            <span>{t(tKey + 'TOTALES.RESUMEN_DIARIO')}</span>
          </Col>
          {(totales && Object.keys(totales).length > 0) ? Object.keys(totales).map((tipoDosis) => {
            let totalPorDosis = totales[tipoDosis]
            return [
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'tipoDosis'}>
                <span>{totalPorDosis.nombreTipoDosis}</span>
              </Col>,
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'totalExtracciones'}>
                <span>{t(tKey+ 'TOTALES.TOTAL_POOLS')}: {totalPorDosis.totalPools !== undefined ? number_formatter(totalPorDosis.totalPools, 0, separadorDec, separadorMil) : 0}</span>
              </Col>,
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'totalDosisProducidas'}>
                <span>{t(tKey+ 'TOTALES.TOTAL_DOSIS_PRODUCIDAS')}: {totalPorDosis.totalDosisProducidas !== undefined ? number_formatter(totalPorDosis.totalDosisProducidas, 0, separadorDec, separadorMil) : 0}</span>
              </Col>,
              <Col sm={3} className="estados-total-verraco" key={tipoDosis + 'totalDosisPedidas'}>
                <span>{t(tKey+ 'TOTALES.TOTAL_DOSIS_PEDIDAS')}: {totalPorDosis.totalDosisPedidas !== undefined ? number_formatter(totalPorDosis.totalDosisPedidas, 0, separadorDec, separadorMil) : 0}</span>
              </Col>
            ]
          }) : (
            <Col sm={12} className="estados-total-verraco" >
              <span>{t(`COMUN.SIN_RESULTADOS`)}</span>
            </Col>
          )}
        </Row>
      </div>
    )
  }
}

export default PoolExtracciones